<template>
  <div>
    
    <div id="phoneModule" >
      <div class="moduleContainer">
        <div id="mapContainer"></div>
      </div>
    </div>
  </div> 
</template>

<script>
export default {
  name: 'wmt-arriveMap',

  data() {
    return {

    };
  }, 
  computed: {

  },
  mounted() {
    var center = new TMap.LatLng(31.236473, 121.501409)
    var map = new TMap.Map(document.getElementById('mapContainer'), {
      center: center, //设置地图中心点坐标
      zoom: 17.2, //设置地图缩放级别
    })
    var markerLayer = new TMap.MultiMarker({
      map: map, //指定地图容器
      //样式定义
      styles: {
        //创建一个styleId为"myStyle"的样式（styles的子属性名即为styleId）
        myStyle: new TMap.MarkerStyle({
          width: 35, // 点标记样式宽度（像素）
          height: 35, // 点标记样式高度（像素）
          src: 'https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeetStatic/website/aboutUs/address.png', //图片路径
          //焦点在图片中的像素位置，一般大头针类似形式的图片以针尖位置做为焦点，圆形点以圆心位置为焦点
          anchor: { x: 16, y: 32 },
        }),
      },
      //点标记数据数组
      geometries: [
        {
          id: '1', //点标记唯一标识，后续如果有删除、修改位置等操作，都需要此id
          styleId: 'myStyle', //指定样式id
          position: new TMap.LatLng(31.236473, 121.501409), //点标记坐标位置
          properties: {
            //自定义属性
            title: 'marker1',
          },
        },
      ],
    })
  },

  methods: {

  },
};
</script>

<style lang="less" scoped>
#phoneModule {
  height: auto !important;
  margin-bottom: 40px;
  padding: 0 14px;
  background: #fff !important;
  .moduleContainer{
    overflow-y: hidden;
  }
  #mapContainer {
    width: 100%;
    height: 200px;
    margin-top: 33px;
  }
}

#singleModule{
    height: auto !important;
    padding-bottom: 105px;
    background: #fff !important;
    .moduleContainer{
      overflow-y: hidden;
    }
    #mapContainer {
    width: 100%;
    height: 400px;
    margin-top: 85px;
  }
}

</style>